<template>
    <q-btn-dropdown color="primary" label="Activo / Inactivo">
        <q-list>
            <q-item tag="label" v-ripple>
                <q-item-section side top>
                    <q-checkbox v-model="activeComputed" />
                </q-item-section>
                <q-item-section>
                    <q-item-label>Activos</q-item-label>
                </q-item-section>
            </q-item>

            <q-item tag="label" v-ripple>
                <q-item-section side top>
                    <q-checkbox v-model="inactiveComputed"/>
                </q-item-section>
                <q-item-section>
                    <q-item-label>Inactivos</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </q-btn-dropdown>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

interface Props {
    active?: boolean;
    inactive?: boolean;
}

export default defineComponent({
    name: 'ActiveDropdownComponent',
    props: {
        active: { type: Boolean },
        inactive: { type: Boolean },
    },
    setup(props: Props, { emit }) {
        const activeComputed = computed({
            get() { return props.active },
            set(newValue) { emit('update:active', newValue) }
        });

        const inactiveComputed = computed({
            get() { return props.inactive},
            set(newValue) { emit('update:inactive', newValue) }
        });

        return {
            activeComputed,
            inactiveComputed,
        }
    }
});

</script>